/* eslint-disable */
// Component builder for Topshop — registers all Sitecore components including
// Topshop-specific ones. Extends the shared component list from @repo/sitecore-lib.

import { ComponentBuilder } from "@sitecore-jss/sitecore-jss-nextjs";

import {
  FAQAttachments,
  FaqHeader,
  HighlightBlock,
  FAQContent,
  MediaCta,
  MediaCtaGrid,
  MediaCarousel,
  ImageList,
  Accordion,
  AccordionSection,
  ContactUs,
  GetInTouchContent,
  GetInTouchActionButtons,
  SearchField,
  SearchResult,
  HelpTopicList,
  PartialDesignDynamicPlaceholder,
  RichText,
  ContainerComponent,
  ImageHeader,
  ImageLink,
  DoubleImage,
  EditorialImage,
  EditorialParagraph,
  EditorialArticle,
  ArticleContainer,
  DenimContainer,
  FeatureCarouselVariants,
  CategoryShowcase,
  VideoPlayer,
  ProductGrid,
} from ".";

export const components = new Map();

components.set("Media CTA", MediaCta);
components.set("Media CTA Container", MediaCtaGrid);
components.set("Hero", MediaCta);
components.set("FAQ Content", FAQContent);
components.set("FAQ Header", FaqHeader);
components.set("FAQ Attachments", FAQAttachments);
components.set("Highlight Block", HighlightBlock);
components.set("Hero Carousel", MediaCarousel);
components.set("FAQ Image Links", ImageList);
components.set("FAQ Image Link", ImageLink);
components.set("Accordion", Accordion);
components.set("FAQ Accordion Section", AccordionSection);
components.set("Accordion Section", AccordionSection);
components.set("Help Topics", HelpTopicList);
components.set(
  "PartialDesignDynamicPlaceholder",
  PartialDesignDynamicPlaceholder,
);
components.set("Search Bar", SearchField);
components.set("Search Results Heading", SearchResult);
components.set("Get In Touch", ContactUs);
components.set("Update Banner", HighlightBlock);
components.set("Rich Text", RichText);
components.set("Page Rich Text", RichText);
components.set("CCFaqContainer", ContainerComponent);
components.set("LegalContainer", ContainerComponent);
components.set("HomeContainer", ContainerComponent);
components.set("FloorContainer", ContainerComponent);
components.set("ComponentsHubContainer", ContainerComponent);
components.set("Image Header", ImageHeader);
components.set("Content Header", GetInTouchContent);
components.set("Get In Touch Buttons", GetInTouchActionButtons);
components.set("EditorialContainer", DenimContainer);
components.set("Double Image", DoubleImage);
components.set("Editorial Image", EditorialImage);
components.set("Editorial Paragraph", EditorialParagraph);
components.set("Article", EditorialArticle);
components.set("ArticleContainer", ArticleContainer);
components.set("ComponentsHubContainer", DenimContainer);
components.set("Feature Carousel", FeatureCarouselVariants);
components.set("Product Grid", ProductGrid);
components.set("Category Product Grid", ProductGrid);
components.set("Category Showcase", CategoryShowcase);
components.set("VideoClickToPlay", VideoPlayer);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
